import webAppMessaging from './iframe-bridge';

const utils = {
  webAppMessaging,
};

export default utils;
